import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SvgIcon } from "@cinch-labs/design-system";
import cx from "classnames";
import React from "react";
import styles from "./carousel-navigation.module.css";
var CarouselNavigation = function(param) {
    var customClassNames = param.customClassNames, _buttonIcons = param.buttonIcons, buttonIcons = _buttonIcons === void 0 ? {
        leftIcon: "chevron-left",
        rightIcon: "chevron-right"
    } : _buttonIcons, ariaLabels = param.ariaLabels, name = param.name;
    var wrapperClassNames = cx(styles.controls, customClassNames === null || customClassNames === void 0 ? void 0 : customClassNames.wrapper);
    var prevBtnClassNames = cx("".concat(name, "-prev"), styles.controlsBtn, styles.controlsBtnPrev, customClassNames === null || customClassNames === void 0 ? void 0 : customClassNames.prevButton);
    var nextBtnClassNames = cx("".concat(name, "-next"), styles.controlsBtn, styles.controlsBtnNext, customClassNames === null || customClassNames === void 0 ? void 0 : customClassNames.nextButton);
    return /*#__PURE__*/ _jsxs("div", {
        "data-slide-controls": true,
        className: wrapperClassNames,
        "data-testid": "ds-carousel-controls",
        children: [
            /*#__PURE__*/ _jsx("button", {
                type: "button",
                className: prevBtnClassNames,
                "aria-label": ariaLabels.previous,
                children: /*#__PURE__*/ _jsx(SvgIcon, {
                    name: buttonIcons.leftIcon,
                    size: 22
                })
            }),
            /*#__PURE__*/ _jsx("button", {
                type: "button",
                className: nextBtnClassNames,
                "aria-label": ariaLabels.next,
                children: /*#__PURE__*/ _jsx(SvgIcon, {
                    name: buttonIcons.rightIcon,
                    size: 22
                })
            })
        ]
    });
};
export default CarouselNavigation;
